const Select = {
  baseStyle: {
    backgroundColor: 'white',
  },
};

export default Select;
